import clsx from 'clsx';

type ProgressBarProps = {
  progress: number;
  height?: number;
  loading?: boolean;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
  loading,
  progress,
  height = 4,
}) => {
  return (
    <div
      style={{ height }}
      className={clsx('bg-bg rounded-sm grow overflow-hidden')}
    >
      <div
        className={clsx(
          'h-full',
          'transition-all',
          loading
            ? 'bg-gradient-to-r from-danger via-active to-main bg-[length:200%_200%] animate-gradient'
            : 'bg-active'
        )}
        style={{ width: loading ? '100%' : `${progress}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
